export const getPngImagePath = (iconName, iconStyle, scale, folderPath) => {
  const size = 32 * Math.round(scale / 16);
  const filename = `${iconName}-${iconStyle}-${size}.png`;
  return `https://d1ccvuha0qk3lj.cloudfront.net/uploads/hostedFiles/Content%20builder%20Icons/${filename}`;
};
